<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <span
    data-slot="color-key-accent"
    :class="cn('font-semibold text-(--key-color) group-data-[layout=hero]/color-key:text-kpi-sm', props.class)"
  >
    <slot />
  </span>
</template>
